export class MercadoriasColoracaoModel {
  id_coloracao: number;
  nome_pt: string;
  nome_en: string;
  nome_es: string;
}



// WEBPACK FOOTER //
// ./src/app/mercadorias-coloracao/mercadorias-coloracao.model.ts